import CategoryDto from "@/projectRoot/api-client/interfaces/models/products/product-entities/Category.dto";


// export function getSortedCategories(unsortedCategories: CategoryDto[]): SortedCategoryItem[] {
//     let arranged: SortedCategoryItem[] = [];
//     let urlFound = false;
//     unsortedCategories.forEach((category) => {
//         if (category.parent_id === '0' || category.parent_id === null || typeof category.parent_id == undefined) {
//             arranged.push(getChildren(category, unsortedCategories, urlFound));
//         }
//     })
//     if (arranged.length == 0 && unsortedCategories.length > 0) {
//         unsortedCategories.forEach((category) => {
//             if (category.ancestor_ids.length == 1) {
//                 arranged.push(getChildren(category, unsortedCategories, urlFound));
//             }
//         })
//         if (arranged.length == 0) {
//             unsortedCategories.forEach((category) => {
//                 if (category.ancestor_ids.length == 2) {
//                     arranged.push(getChildren(category, unsortedCategories, urlFound));
//                 }
//             })
//         }
//     }
//     return arranged;
// }

// export function getSortedChildrenCategories(categoryId: string, unsortedCategories: CategoryDto[], onlyChildren: boolean = false): SortedCategoryItem[] {
//     let category: CategoryDto | undefined;
//     let response: SortedCategoryItem[] = [];
//     category = unsortedCategories.find((category) => category.id == categoryId);
//     if (category) {
//         if (category.ancestor_ids.length > 0 && !onlyChildren) {
//             const parent = unsortedCategories.find((cat) => cat.id == category?.ancestor_ids[0]);
//             if (parent) {
//                 response = getChildren(parent, unsortedCategories, false).children;
//             }
//         } else {
//             response = getChildren(category, unsortedCategories, false).children;
//         }
//     }
//     return response;
// }

// export function getSortedChildrenOrSiblings(categoryId: string, unsortedCategories: CategoryDto[]): SortedCategoryItem[] {
//     let category: CategoryDto | undefined;
//     let returnableCats: CategoryDto[] = [];
//     let response: SortedCategoryItem[] = [];
//     category = unsortedCategories.find((singleCat) => singleCat.id == categoryId);
//     if (category) {
//         returnableCats = unsortedCategories.filter((cat) => cat.parent_id == category?.id);
//         if (returnableCats.length > 0) {
//             response = returnableCats.map((child) => { return { ...child, children: [] } });
//         } else {
//             returnableCats = unsortedCategories.filter((cat) => cat.parent_id == category?.parent_id);
//             response = returnableCats.map((sibling) => { return { ...sibling, children: [] } });
//         }
//     }
//     return response;
// }

// export function getChildren(parent: CategoryDto, categories: CategoryDto[], urlFound?: boolean) {
//     let sortedChildren: SortedCategoryItem[] = [];
//     let sortedParent: SortedCategoryItem;
//     let children = categories.filter((children) => parent.id == children.parent_id);
//     children.forEach((child) => {
//         let childUrlFound = false;
//         sortedChildren.push(getChildren(child, categories, childUrlFound));
//     });
//     sortedParent = { ...parent, children: sortedChildren };
//     if (urlFound) {
//         sortedParent.isCurrentUrl = true;
//     }
//     return sortedParent;
// }

export function getSpecificCategory(categories: CategoryDto[], checkValue: string): CategoryDto | undefined {
    let response: CategoryDto | undefined;
    let firstLevel: CategoryDto | undefined = categories.find(cat => cat.id == checkValue);
    if (firstLevel) {
        response = firstLevel;
        return response;
    }

    for (let firstLevel of categories) {
        let secondLevel: CategoryDto | undefined = firstLevel.children.find(cat => cat.id == checkValue);

        if (secondLevel) {
            response = secondLevel;
            return response;
        }

        for (let secondLevel of firstLevel.children) {
            let thirdLevel: CategoryDto | undefined = secondLevel.children.find(cat => cat.id == checkValue);

            if (thirdLevel) {
                response = thirdLevel;
                return response;
            }
        }
    }


    return response;
}